import { render, staticRenderFns } from "./merchant-detail.vue?vue&type=template&id=0882f144&scoped=true"
import script from "./merchant-detail.vue?vue&type=script&lang=js"
export * from "./merchant-detail.vue?vue&type=script&lang=js"
import style0 from "./merchant-detail.vue?vue&type=style&index=0&id=0882f144&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0882f144",
  null
  
)

export default component.exports